import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { ThemeProvider } from '@material-ui/styles'
import { CssBaseline } from '@material-ui/core/'
import { Navbar, Footer } from '..'
import ModalController from '../../../HOC/ModalController'

import { Provider as ModalContextProvider } from '../../../context/ModalContext'
import { lightTheme } from '../../../App.theme'
import useStyles from './styles'

import { SEO } from '../../_common'

if (typeof window !== 'undefined') {
  // eslint-disable-next-line global-require
  require('smooth-scroll')('a[href*="#"]')
}

const Layout = ({ children, withNav, seoTitle = '', seoDescription = '' }) => {
  const { main } = useStyles({ withNav })

  return (
    <Fragment>
      <SEO title={seoTitle} description={seoDescription} />
      <ModalContextProvider>
        <ThemeProvider theme={lightTheme}>
          <CssBaseline />
          <ModalController />
          <Navbar withNav={withNav} />
          <main className={main}>{children}</main>
          <Footer />
        </ThemeProvider>
      </ModalContextProvider>
    </Fragment>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
